import {
  SET_VIEWPORT_OBJECT,
  GET_IS_MOBILE_VIEWPORT,
  VIEWPORT_LABEL_MOBILE,
} from '../services/constants'

const module = {
  state: {
    currentViewportInfo: {
      label: '',
      rule: '',
    },
  },
  getters: {
    [GET_IS_MOBILE_VIEWPORT](state) {
      return state.currentViewportInfo.label === VIEWPORT_LABEL_MOBILE
    }
  },
  mutations: {
    [SET_VIEWPORT_OBJECT](state, payload) {
      state.currentViewportInfo = payload
    },
  },
}

export default module
export const renderModule = module
